/* aq-journal.js — 2026-10-27 (Claude). Guide-page behaviour on the Journal.
   Draws a live product rail (four tiles, live price, Bestseller badge) under the post's shop card, fetched from
   the collection the card links to. The body itself is a single centered column (aq-journal.css); the earlier
   alternating-halves regrouping was removed on the owner's call the same day. No post body is edited. */
(function () {
  'use strict';
  var root = document.querySelector('.aqg');
  if (!root) return;
  var col = root.querySelector('.aqg-col:not(.aqg-hero)');
  if (!col) return;
  var original = Array.prototype.slice.call(col.children);   // flow order; the rail is spliced in when it arrives
  var collection = null;

  var has = function (el, c) { return el.classList && el.classList.contains(c); };
  var esc = function (t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var img = function (src, w) { return src ? src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; };
  function money(v) {
    var n = parseFloat(v); if (isNaN(n)) return '';
    var s = n % 1 === 0 ? String(n) : n.toFixed(2);
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    return cur === 'USD' ? '$' + s : s + ' ' + cur;
  }
  function priceOf(p) {
    var prices = p.variants.filter(function (v) { return v.available; }).map(function (v) { return parseFloat(v.price); });
    var min = Math.min.apply(null, prices), max = Math.max.apply(null, prices);
    return (max > min ? 'From ' : '') + money(min);
  }
  function tile(p, spot) {
    var best = (p.tags || []).some(function (t) { return /^best ?seller$/i.test(String(t).trim()); });
    return '<a class="aqg-ptile' + (spot ? ' aqg-ptile--spot' : '') + '" href="/products/' + encodeURIComponent(p.handle) + '">' +
      '<span class="aqg-ptile__frame">' + (best ? '<span class="aqg-ptile__badge">Bestseller</span>' : '') +
      '<img src="' + esc(img(p.images[0].src, spot ? 900 : 600)) + '" alt="' + esc(p.images[0].alt || p.title) + '" loading="lazy" data-pin-description="' + esc(p.title + ' · Aquamarise') + '"></span>' +
      (spot ? '<span class="aqg-ptile__kicker">From the studio</span>' : '') +
      '<span class="aqg-ptile__title">' + esc(p.title) + '</span>' +
      '<span class="aqg-ptile__price">' + esc(priceOf(p)) + '</span>' +
      '<span class="aqg-ptile__btn">Shop</span></a>';
  }

  /* ---- restore the flat flow ---- */
  function unwrap() {
    original.forEach(function (el) { col.appendChild(el); });
    Array.prototype.slice.call(col.children).forEach(function (el) {
      if (original.indexOf(el) === -1) col.removeChild(el);
    });
  }

  /* ---- keep the flow in document order; the rail is spliced into `original` when it arrives ---- */
  function layout() { unwrap(); }

  /* ---- collection + products ---- */
  function collectionFrom(sel) {
    var links = root.querySelectorAll(sel + ' a[href*="/collections/"]');
    for (var i = 0; i < links.length; i++) {
      var m = links[i].getAttribute('href').match(/\/collections\/([^\/?#]+)/);
      if (m) return { handle: decodeURIComponent(m[1]), href: links[i].getAttribute('href') };
    }
    return null;
  }
  var anchor = root.querySelector('.aqg-shop');
  collection = (anchor && collectionFrom('.aqg-shop')) || collectionFrom('.aqg-cta') || collectionFrom('.aqg-band');
  if (!anchor) {
    var secs = root.querySelectorAll('.aqg-col h2.sec');
    anchor = secs.length > 2 ? secs[2].previousElementSibling : null;
  }

  layout();

  if (!collection) return;
  fetch('/collections/' + encodeURIComponent(collection.handle) + '/products.json?limit=12', { credentials: 'same-origin' })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (d) {
      if (!d || !d.products) return;
      var ok = d.products.filter(function (p) {
        return p.images && p.images.length && p.variants && p.variants.some(function (v) { return v.available; });
      });
      if (ok.length < 2) return;
      var rail = ok.slice(0, 4);
      if (anchor && !root.querySelector('.aqg-products')) {
        var sec = document.createElement('section');
        sec.className = 'aqg-products';
        sec.setAttribute('aria-label', 'Shop this story');
        sec.innerHTML = '<div class="aqg-products__head"><h3>From the studio</h3><a href="' + esc(collection.href) + '">Shop all →</a></div>' +
          '<div class="aqg-products__grid">' + rail.map(function (p) { return tile(p, false); }).join('') + '</div>';
        var at = original.indexOf(anchor);
        if (at > -1) original.splice(at + 1, 0, sec); else original.push(sec);
      }
      layout();
    })
    .catch(function () {});
})();
